import { call, put, takeEvery } from 'redux-saga/effects';
import { getSingleScanApi } from '../api/singleScanApi';
import { singleScanFailure, singleScanSuccess } from '../actions/singleScanActions';
import { SINGLE_SCAN_REQUEST } from '../constants/singleScanConstants';

function* fetchSingleScan(action) {
  try {
    const response = yield call(getSingleScanApi, action.payload);
    yield put(singleScanSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch single scan list';
    yield put(singleScanFailure(errorMessage));
  }
}

function* singleScanSaga() {
  yield takeEvery(SINGLE_SCAN_REQUEST, fetchSingleScan);
}

export default singleScanSaga;